import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FilterPeriodType } from '../../utils/constants';

interface FilterConsumerUnitState {
  filterState: string;
  utilityCompanyId: string;
  period: (typeof FilterPeriodType)[keyof typeof FilterPeriodType];
  monthSelected: Date | null;
  startDate: Date | null;
  endDate: Date | null;
}

const initialState = {
  filterState: 'all',
  utilityCompanyId: 'all',
  period: FilterPeriodType.CURRENT_YEAR,
  monthSelected: null,
  startDate: null,
  endDate: null,
} as FilterConsumerUnitState;

const filterConsumerUnitSlice = createSlice({
  name: 'filterConsumerUnit',
  initialState,
  reducers: {
    setFilterState: (
      state,
      { payload: { filterState } }: PayloadAction<{ filterState: string }>
    ) => {
      state.filterState = filterState;
    },
    setFilterUtilityCompanyId: (
      state,
      {
        payload: { utilityCompanyId },
      }: PayloadAction<{ utilityCompanyId: string }>
    ) => {
      state.utilityCompanyId = utilityCompanyId;
    },
    setFilterPeriod: (
      state,
      { payload: { period } }: PayloadAction<{ period: FilterPeriodType }>
    ) => {
      state.period = period;
    },
    setFilterMonthSelected: (
      state,
      {
        payload: { monthSelected },
      }: PayloadAction<{ monthSelected: Date | null }>
    ) => {
      state.monthSelected = monthSelected;
    },
    setFilterStartDate: (
      state,
      { payload: { startDate } }: PayloadAction<{ startDate: Date | null }>
    ) => {
      state.startDate = startDate;
    },
    setFilterEndDate: (
      state,
      { payload: { endDate } }: PayloadAction<{ endDate: Date | null }>
    ) => {
      state.endDate = endDate;
    },
  },
});

export const {
  setFilterState,
  setFilterUtilityCompanyId,
  setFilterPeriod,
  setFilterMonthSelected,
  setFilterStartDate,
  setFilterEndDate,
} = filterConsumerUnitSlice.actions;

export default filterConsumerUnitSlice.reducer;
